import { render, staticRenderFns } from "./CoaList.vue?vue&type=template&id=5287e59a&scoped=true&"
import script from "./CoaList.vue?vue&type=script&lang=js&"
export * from "./CoaList.vue?vue&type=script&lang=js&"
import style0 from "./CoaList.vue?vue&type=style&index=0&id=5287e59a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5287e59a",
  null
  
)

export default component.exports